import { SWITCH_DEVICE } from '../actions/types';

const defaultState = 'mobile';

/* eslint-disable import/prefer-default-export */
export const deviceReducer = (state = defaultState, action) => {
    if (action.type === SWITCH_DEVICE) {
        return action.payload;
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/client-device.js
 **/